import React, { useEffect, useState } from "react";
import "./CreditManagement.css";
import { DatePicker } from "antd";
import { BASE_URL, fromdate, Messante_URL } from "./apiConfig";
import Swal from "sweetalert2";

export default function CreditManagement() {

    const [activeTab, setActiveTab] = useState("history");
    const [seller, setSeller] = useState("");
    const [client, setClient] = useState("");
    const [addCredit, setAddCredit] = useState("");
    const [remark, setRemark] = useState("");
    const [daterangevalue, setDateRangevalue] = useState('');
    const [guiuser, setguiuser] = useState('');
    const [distinctSeller, setdistinctSeller] = useState([]);
    const [distinctuser, setdistinctuser] = useState([]);
    const [showprogress, setshowprogress] = useState(false);
    const [creditHistoryAPI, setcreditHistoryAPI] = useState([]);
    const [userBalanceAPIData, setuserBalanceAPIData] = useState([]);

    const loginData = JSON.parse(sessionStorage.getItem("loginData"));
    const sessionusertype = loginData?.utype?.usertype;
    const sessionusername = loginData?.guiuserid;
    const sessionapiuser = loginData?.apiuserid;

    const { RangePicker } = DatePicker;

    const today = new Date();
    // Calculate yesterday's date
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);

    // Format yesterday's date as 'YYYY-MM-DD'
    const formattedYesterday = yesterday.toISOString().split('T')[0];

    const [dateRange, setDateRange] = useState([]);
    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();

    const formatDate = (date) => {
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, '0');
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const year = d.getFullYear();
        return `${day}-${month}-${year}`;
    };

    const handleDateChange = (dates) => {
        setDateRangevalue(dates);
        // Update the state with the date range
        console.log("change Range" + dates);
        console.log("daterange:" + dateRange);

        const dateOnlyStrings = dates ? dates.map((dateString) => {
            const date = new Date(dateString);
            return date.toISOString().split("T")[0] || "2023-10-01";
        }) : ["2023-10-01", "2023-10-31"];

        let [sDate, eDate] = dateOnlyStrings;

        // Add one day to both start date and end date
        if (sDate) {
            const startDate = new Date(sDate);
            startDate.setDate(startDate.getDate() + 1);
            sDate = startDate.toISOString().split("T")[0];
        }

        if (eDate) {
            const endDate = new Date(eDate);
            endDate.setDate(endDate.getDate() + 1);
            eDate = endDate.toISOString().split("T")[0];
        }

        setStartDate(sDate);
        setEndDate(eDate);
    };

    const callDistinctGUIUser = async () => {
        let usr = "";
        if (seller !== "") {
            usr = seller;
        }

        else {
            usr = sessionusername;
        }
        const apiUrl = `${BASE_URL}/AllUsers?uid=${usr}&fromwhere=1`;

        const fetchOptions = {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
        };
        setshowprogress(true);
        try {

            const response = await fetch(apiUrl, fetchOptions);
            setshowprogress(false);
            if (!response.ok) {
                throw new Error(`API request failed with status ${response.status}`);
            }

            const data = await response.json();

            const filteredData = data.filter(
                (option) => String(option?.utype) === "2"
            );

            const filteredUserData = data.filter(
                (option) => String(option?.utype) === "1"
            );
            console.log(data);

            if (seller === "") {
                setdistinctSeller(filteredData);
                setdistinctuser(filteredUserData);
            }

            else {
                setdistinctuser(filteredUserData);
            }
        } catch (error) {
            setshowprogress(false);
            console.error("API Request Error:", error.message);
        }
    };

    const callGetCreditHistory = async () => {
        if (sessionusertype !== 1 && (!guiuser && !seller)) {
            console.log("Inside if");
            const re = await Swal.fire({
                title: "Value Error!",
                text: "Please Select at least One among User or Seller or Reseller",
                icon: "error",
                allowOutsideClick: false
            });
        }

        else {
            console.log("Inside else");
            try {
                let pusr = "";
                if (sessionusertype === 1) {
                    pusr = sessionapiuser;
                }

                else {
                    pusr = guiuser || seller;
                }

                setshowprogress(true);
                console.log("daterangevalue:", daterangevalue)
                const stDate = daterangevalue === "" ? "" : startDate;
                const etDate = daterangevalue === "" ? "" : endDate;
                const apiUrl = `${Messante_URL}/Credithistory?puser=${pusr}&sdate=${stDate}&edate=${etDate}`;
                const fetchOptions = {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                    }
                };

                // API Request
                const response = await fetch(apiUrl, fetchOptions);
                const data = await response.json();

                setshowprogress(false);

                if (data.status === "Success" || data.errorCode === "000") {
                    const enterpriseData = Array.isArray(data?.lst) ? data?.lst : [];
                    setcreditHistoryAPI(enterpriseData);
                }

                else {
                    setcreditHistoryAPI([]);
                }
            }

            catch (error) {
                console.error("API Request Error:", error.message);
                setshowprogress(false);
            }
        }
    };

    
    const callGetUserBalance = async () => {
        if (sessionusertype !== 1 && (!guiuser && !seller)){
              console.log("Inside BALANCE if");
            const re = await Swal.fire({
                title: "Value Error!",
                text: "Please Select at least One among User or Seller",
                icon: "error",
                allowOutsideClick: false
            });
        }

        else {
              console.log("Inside BALANCE ELSE");
            try {
               let pusr = "";
                if (sessionusertype === 1) {
                    pusr = sessionapiuser;
                }

                else {
                    pusr = guiuser || seller;
                }
                setshowprogress(true);
                const apiUrl = `${Messante_URL}/userbalancecheck?puser=${pusr}`;
                const fetchOptions = {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                    }
                };

                // API Request
                const response = await fetch(apiUrl, fetchOptions);
                const data = await response.json();

                setshowprogress(false);

                if (data.status === "Success" || data.errorCode === "000") {
                    const enterpriseData = Array.isArray(data?.lst) ? data?.lst : [];
                    setuserBalanceAPIData(enterpriseData);
                }

                else {
                    setuserBalanceAPIData([]);
                }
            }

            catch (error) {
                console.error("API Request Error:", error.message);
                setshowprogress(false);
            }
        }
    };

    useEffect(() => {
        if (sessionusertype !== 2) {
            callDistinctGUIUser();
        }
    }, []);

    useEffect(() => {
        if (seller !== "" || sessionusertype === 2) {
            callDistinctGUIUser();
        }

        setguiuser("");
    }, [seller, sessionusertype])

    return (
        <div className="credit-page" style={{position:"relative"}}>
{showprogress === true ? <div className="spinner-overlay">
                    <div className="custom-spinner"></div>
                </div> : <div></div>}

            <div className={showprogress ? "credit-page-title blurred" : "credit-page-title" }>
                <span>Credit Management</span>

                {/* <div className="credit-breadcrumb">
                    <span className="breadcrumb-home">Home</span>
                    <span className="breadcrumb-arrow">›</span>
                    <span>Credit Management</span>
                </div> */}
            </div>


            {/* =====================================================
                MAIN CONTENT
            ====================================================== */}

            <div className={showprogress === true ? "credit-content blurred":"credit-content"}>


                {/* =================================================
                    TABS
                ================================================== */}

                <div className="credit-tabs" style={{ marginBottom: "0.7rem" }}>

                    {/* <button
                        type="button"
                        className={`credit-tab ${
                            activeTab === "add" ? "active" : ""
                        }`}
                        onClick={() => setActiveTab("add")}
                    >
                        ADD
                    </button>

                    <button
                        type="button"
                        className={`credit-tab ${
                            activeTab === "deduct" ? "active" : ""
                        }`}
                        onClick={() => setActiveTab("deduct")}
                    >
                        DEDUCT
                    </button> */}



                    <button
                        type="button"
                        className={`credit-tab ${activeTab === "history" ? "active" : ""
                            }`}
                        onClick={() => setActiveTab("history")}
                    >
                        CREDIT HISTORY
                    </button>

                    {sessionusertype !== 1 && (<button
                        type="button"
                        className={`credit-tab ${activeTab === "view" ? "active" : ""
                            }`}
                        onClick={() => setActiveTab("view")}
                    >
                        VIEW BALANCE
                    </button>
                    )}

                </div>



                <div style={{ maxWidth: "100%", display: "flex", justifyContent: "space-between", alignItems: "center", flex: "0 0 100%", flexWrap: "wrap" }}>
                    {sessionusertype === 0 && (
                        <div className="credit-flex-div">

                            <label>Select Seller</label>

                            <select
                                className="form-control"
                                value={seller}
                                onChange={(e) => setSeller(e.target.value)}
                            >
                                <option value="">Select Seller</option>

                                {distinctSeller.map((option, index) => (
                                    <option
                                        key={option.guiuserid || index}
                                        value={option.guiuserid}
                                    >
                                        {option.guiuserid}
                                    </option>
                                ))}
                            </select>


                        </div>
                    )}

                    <div
                        className={
                            sessionusertype !== 0
                                ? "child-credit-flex-div"
                                : "credit-flex-div"
                        }
                    >
                        <label>API User</label>

                        {sessionusertype === 1 ? (
                            <input
                                className="form-control"
                                disabled
                                value={sessionapiuser || ""}
                                style={{ background: "#e5dede" }}
                            />
                        ) : (
                            <select
                                className="form-control"
                                value={guiuser}
                                onChange={(e) => setguiuser(e.target.value)}
                            >
                                <option value="">Select User</option>

                                {distinctuser.map((option, index) => (
                                    <option
                                        key={option.guiuserid || index}
                                        value={option.guiuserid}
                                    >
                                        {option.guiuserid}
                                    </option>
                                ))}
                            </select>
                        )}
                    </div>
                    {activeTab === "history" && (
                        <div className={sessionusertype === 0 ? "credit-flex-div-st" : "child-credit-flex-div"}>
                            <label>Date Range</label>
                            <RangePicker
                                value={daterangevalue}
                                size="large"
                                className="neuromorphic-input"
                                onChange={handleDateChange}

                                style={{ border: "1px dotted black", width: "100%", height: "2.3rem" }}
                                disabledDate={(current) => {
                                    const fromDate = new Date(fromdate); // Replace with your actual fromdate
                                    const today = new Date();
                                    today.setHours(23, 59, 59, 999); // End of today's date

                                    // Disable dates before `fromDate` and after today
                                    return current && (current < fromDate || current > today);
                                }}
                            />
                        </div>
                    )}

                    {activeTab == "view" && (
                        <div className={sessionusertype === 0 ? "credit-flex-div-st" : "child-credit-flex-div"}>
                            <label>Service</label>
                            <input className="form-control" value="SMS" disabled={true} style={{ background: "#e5dede" }} />
                        </div>
                    )}

                    <div className="credit-button-div">
                        <button className=" btn btn-info" onClick={() => {
                           activeTab === "view" ? callGetUserBalance() : callGetCreditHistory();
                        }}>
                            Search
                        </button>
                    </div>

                </div>



            </div>

            <div className={showprogress === true ? "credit-content blurred":"credit-content"} style={{ padding: "0" }}>


                {activeTab === "history" && (
                    <table className="table table-bordered" style={{ fontSize: "0.82rem", overflow: "auto" }}>
                        <thead style={{ backgroundColor: "skyblue", fontWeight: "500" }}>
                            <tr>
                                <th>User ID</th>
                                <th>User Type</th>
                                <th>Activity Type</th>
                                <th>Value Type</th>
                                <th>Value</th>
                                <th>Activity Time</th>
                            </tr>
                        </thead>
                        <tbody>
                            {creditHistoryAPI && creditHistoryAPI.length > 0 ? (
                                creditHistoryAPI.map((row, index) => (
                                    <tr key={index}>
                                        <td>{row.userID}</td>
                                        <td>{row.user_type}</td>
                                        <td>{row.activitytype}</td>
                                        <td>{row.valuetype}</td>
                                        <td>{row.value}</td>
                                        <td>{row.activitytime}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="6" style={{ textAlign: "center" }}>
                                        No records found
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                )}

                {activeTab === "view" && (
                    <table className="table table-bordered" style={{ fontSize: "0.82rem", overflow: "auto" }}>
                        <thead style={{ backgroundColor: "skyblue", fontWeight: "500" }}>
                            <tr>
                                <th>User ID</th>
                                <th>Service</th>
                                <th>Balance Amount</th>
                                <th>Last Updated At</th>
                            </tr>
                        </thead>
                        <tbody>
 {userBalanceAPIData && userBalanceAPIData.length > 0 ? (
                                userBalanceAPIData.map((row, index) => (
                                    <tr key={index}>
                                        <td>{row.userID}</td>
                                        <td>{row.channelid}</td>
                                        <td>{row.total_balance}</td>
                                        <td>{row.lastupdatetime}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="4" style={{ textAlign: "center" }}>
                                        No records found
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                )}
            </div>

        </div>
    );
}